const appendValueToFormData = (formData, key, value) => {
    if (value === undefined || value === null) {
        return;
    }

    if (value instanceof File) {
        formData.append(key, value);
        return;
    }

    if (Array.isArray(value)) {
        value.forEach((item, index) => {
            appendValueToFormData(formData, `${key}[${index}]`, item);
        });
        return;
    }

    if (typeof value === "object") {
        Object.keys(value).forEach((childKey) => {
            appendValueToFormData(formData, `${key}[${childKey}]`, value[childKey]);
        });
        return;
    }

    formData.append(key, value);
};

const getGalleryImageValue = (image) => {
    return image?.id || image?.path || image?.url || image;
};

export const buildProductFormData = ({
    productData,
    galleryFiles = [],
    deletedGalleryImages = [],
    orderedGalleryImages = [],
    method,
}) => {
    const formData = new FormData();

    Object.keys(productData).forEach((key) => {
        appendValueToFormData(formData, key, productData[key]);
    });

    const deletedGalleryImageValues = new Set(deletedGalleryImages.map(getGalleryImageValue).filter(Boolean));
    const activeOrderedGalleryImages = orderedGalleryImages.filter((image) => {
        const value = getGalleryImageValue(image);

        return value && !deletedGalleryImageValues.has(value);
    });

    galleryFiles.forEach((file) => {
        formData.append("gallery[]", file);
    });

    deletedGalleryImages.forEach((image, index) => {
        const value = getGalleryImageValue(image);

        if (value) {
            formData.append(`deleted_gallery_images[${index}]`, value);
            formData.append(`gallery_deleted[${index}]`, value);
            formData.append(`gallery_delete[${index}]`, value);
            formData.append(`delete_gallery[${index}]`, value);
        }
    });

    activeOrderedGalleryImages.forEach((image, index) => {
        const value = getGalleryImageValue(image);

        if (value) {
            formData.append(`gallery_order[${index}][id]`, value);
            formData.append(`gallery_order[${index}][order]`, index);
            formData.append(`gallery_sort[${index}][id]`, value);
            formData.append(`gallery_sort[${index}][order]`, index);
        }
    });

    if (method) {
        formData.append("_method", method);
    }

    return formData;
};

export const buildGalleryFormData = (galleryFiles = []) => {
    const formData = new FormData();

    galleryFiles.forEach((file) => {
        formData.append("gallery[]", file);
    });

    return formData;
};
